import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type State = Partial<Record<string, boolean>>;

export const settingsSectionVisibilitySlice = createSlice({
    name: "settingsSectionVisibility",
    initialState: {} as State,
    reducers: {
        configureVisibility: (state, action: PayloadAction<Record<string, boolean>>) => ({
            ...state,
            ...action.payload,
        }),
        resetSettingsSectionVisibility: () => ({}),
    },
});

const { actions, reducer } = settingsSectionVisibilitySlice;
export { actions as settingsSectionVisibilityActions, reducer as settingsSectionVisibilityReducer };
